"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { WorkspaceElementType } from '@membranehq/sdk';
import { useElement } from '../element/useElement.mjs';

function useAppEventType(selector) {
  const { item: appEventType, ...rest } = useElement(
    WorkspaceElementType.AppEventType,
    selector,
    (integrationApp) => selector ? integrationApp.appEventType(selector) : void 0
  );
  return { appEventType, ...rest };
}

export { useAppEventType };
